export class ListEntry {
  public list: any[];
  public updated: number;
  public id: string;

  constructor(id = null, list = null, updated = null) {
    this.id = id;
    this.list = list;
    this.updated = updated;
  }
}
